import React from "react";
import i18n from "i18next";
import k from "src/i18n/keys";

const Preparation = () => {
  return (
    <div>
      <span> {i18n.t(k.AI_CHECKLIST_PREPARATION)}</span>
    </div>
  );
};

export default Preparation;
